const checkErrorLiveAccountUnique = (errorFields) => errorFields?.ecommerceId?.status === 'error' && errorFields?.name?.status === 'error';

export default checkErrorLiveAccountUnique;
